<template>
  <div class="flex-col">
    <div class="text-14-black33-b margin-top-16">{{ label }}</div>
    <div
      v-for="(child, count) in children"
      :key="count"
      :class="groupBoxStyle"
      class="flex-col margin-top-16"
    >
      <!--操作bar-->
      <div
        v-if="showGroupHandlerBar"
        class="flex-row-center-jx flex-between padding-h-16 height-32"
        :class="repeatable ? 'border-bottom-1' : 'border-eb-1'"
      >
        <div class="barTitle flex-row-center-jx">
          <span v-show="repeatable" class="text-14-black33"
            >{{ label }}{{ count + 1 }}</span
          >
        </div>
        <div class="flex">
          <span v-if="hintLabel" class="text-14-gray99">{{ hintLabel }}</span>
          <div
            v-if="ocrConfigs && ocrConfigs.length > 0"
            class="scanArea flex-row-center-jx"
          >
            <div
              v-for="(config, index) in ocrConfigs"
              :key="index"
              class="margin-left-16"
            >
              <div
                v-if="showScanBtn(config, child)"
                @click="doOcr(count, config, child)"
                class="flex-row-center-jx btn-hover"
              >
                <i class="el-icon-camera color-orangeFF" />
                <span class="text-14-orangeFF margin-left-4">{{
                  config.label
                }}</span>
              </div>
            </div>
          </div>
          <el-dropdown
            v-if="distinctions && distinctions.length > 0"
            @command="handleCommand($event, child)"
          >
            <span class="el-dropdown-link text-14-orangeFF margin-left-16">
              {{ child[0].dropdownName }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="item"
                v-for="(item, index) in distinctions"
                :key="index"
              >
                {{ item.label }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <!--child内容-->
      <div class="flex-row flex-between">
        <div class="flex-array-h margin-bottom-16 match-parent-w">
          <div
            v-for="(pro, index) in child"
            :key="index"
            :class="getItemWidth(pro)"
          >
            <div
              :is="conditionView"
              :condition-data="pro"
              v-if="
                pro.type === 'condition-picker' ||
                pro.type === 'condition-select'
              "
              @onConditionDataChange="onConditionChange(pro, $event)"
            />
            <div
              :is="groupSecond"
              v-else-if="pro.type === 'group'"
              :group-data="pro"
              @groupChildrenChange="groupDataChange(pro, $event)"
            />
            <!--                        <base-form-view v-else :out-data="pro" @onValueChange="onFormValueChange(pro,$event,child)"/>-->
            <div
              v-else
              :out-data="pro"
              @onValueChange="onFormValueChange(pro, $event, child)"
              :is="groupEssential"
            ></div>
          </div>
        </div>
        <div
          v-if="couldEdit"
          class="deleteBtn flex-col-center btn-hover"
          @click="deleteCur(child, count, label)"
        >
          <span class="text-14-gray66">{{
            count === 0 && label != "反担保人信息" ? "重置" : "删除"
          }}</span>
        </div>
      </div>
    </div>
    <div
      v-if="couldEdit"
      class="addNewBox height-40 flex-row-center btn-hover"
      @click="addNewOne(label)"
    >
      <i class="el-icon-plus color-orangeFF" />
      <span class="text-14-orangeFF margin-left-4">新增{{ label }}</span>
    </div>
  </div>
</template>

<script>
import FormGroupSecondView from "../../formGroupSecond";
import ConditionSelectView from "../../conditionSelectView";
import BaseFormView from "../../formView";

export default {
  name: "formGroupView",
  components: { BaseFormView, FormGroupSecondView, ConditionSelectView },
  data() {
    return {
      label: "",
      value: null,
      items: null,
      ocrConfigs: null,
      type: "group",
      repeatable: false,
      required: false,
      key: null,
      children: null,
      restaurants: [], //装入自动填充的数据里面
      dialogVisible: false,
      curOcrIndex: -1,
      conditionView: "",
      conditionSpecialView: "",
      groupSecond: "",
      groupEssential: "",
      distinctions: null,
      new_dropdownName: null,
    };
  },
  props: {
    groupData: {
      type: Object,
      default() {
        return null;
      },
    },
    disable: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  watch: {
    groupData: {
      handler(newValue) {
        // 外部数据发生变化
        console.log("groupData-newValue=", newValue);
        this.analysisData(newValue);
      },
      immediate: true,
    },
  },
  computed: {
    groupBoxStyle() {
      let style = "";
      if (this.repeatable) {
        style += " border-eb-1";
      }
      return style;
    },
    showGroupHandlerBar() {
      return this.repeatable || !this.$verify.isEmptyArray(this.ocrConfigs);
    },
    couldEdit() {
      return this.repeatable && !this.disable;
    },
    hintLabel() {
      if (!this.$verify.isEmptyArray(this.ocrConfigs)) {
        let ocrLabel = "";
        for (let i = 0; i < this.ocrConfigs.length; i++) {
          if (i > 0) {
            ocrLabel += "/";
          }
          ocrLabel += this.ocrConfigs[i].label;
          if (i === this.ocrConfigs.length - 1) {
            ocrLabel += "等";
          }
        }
        return ``;
      }
      return "";
    },
  },
  mounted() {
    this.conditionView = (resolve) => {
      require([`../../conditionSelectView`], resolve);
    };

    this.groupSecond = (resolve) => {
      require([`../../formGroupSecond`], resolve);
    };
    this.groupEssential = (resolve) => {
      require([`../../formView`], resolve);
    };
    this.$nextTick(() => {
      this.$root.$on("goBack_Vue", this.getModification);
    });
  },
  destroyed() {
    this.$root.$off("goBack_Vue", this.getModification);
  },
  methods: {
    showScanBtn(config, child) {
      let { ocr } = config;
      if (ocr !== "IDCardRead") return true;
      if (child[0].type !== "condition-select") return true;
      return child[0].value === "idCard" || child[0].value === "personal";
    },
    analysisData(newData) {
      let {
        label,
        key,
        value,
        items,
        ocrConfigs,
        ocrSelect,
        type,
        repeatable,
        required,
        children,
      } = newData;

      this.label = label;
      this.value = value;
      this.items = items;
      this.ocrConfigs = ocrConfigs;

      this.distinctions = ocrSelect;
      this.type = type;
      this.repeatable = repeatable;
      this.required = required;
      this.key = key;
      if (children.length != 0) {
        if (
          children[0][0].type !== "condition-select" &&
          !this.$verify.isEmptyArray(ocrSelect)
        ) {
          children[0][0].dropdownName = ocrSelect[0].label;
        }
      }

      this.children = children;
      if (newData.key === "litigants") {
        console.log(children, "当事人的状态判断");
        let obligor = [];
        this.children.forEach((item) => {
          let verifyInformation = {};
          item.forEach((ergodic) => {
            if (ergodic.value) {
              verifyInformation[ergodic.key] = ergodic.value;
            }
          });
          obligor.push(verifyInformation);
        });

        localStorage.setItem("makeClear", JSON.stringify(obligor));
      }
    },
    onFormValueChange(item, newValue, currentChild) {
      
      let newCaching = JSON.parse(localStorage.getItem("restaurants"));
      if (Object.prototype.toString.call(newValue) !== "[object Object]") {
        this.$set(item, "value", newValue);
        // this.$emit('groupChildrenChange', this.children);
        this.handleGroupDataChildren(this.children);
        let parameter = {};
        let newIndex;
        currentChild.forEach((res) => {
          parameter[res.key] = res.value;
        });
        if (parameter["name"] && item.label !== "收件人") {
          newIndex = newCaching.findIndex((item) => {
            return item.name == parameter["name"];
          });
        }

        if (newIndex != -1 && newIndex != undefined) {
          newCaching[newIndex] = parameter;
        } else if (newIndex === -1) {
          newCaching.push(parameter);
        }
        localStorage.setItem("restaurants", JSON.stringify(newCaching));
      } else {
        for (let key in newValue) {
          currentChild.forEach((item) => {
            if (key === item.key) {
              item.value = newValue[key];
              this.$set(item, "value", newValue[key]);
            } else {
              if (item.key === "telePhone" && key == "telphone") {
                item.value = newValue[key];
                this.$set(item, "value", newValue[key]);
              }
            }
          });
        }
        this.groupEssential = "";
        this.groupEssential = (resolve) => {
          require([`../../formView`], resolve);
        };
        this.handleGroupDataChildren(this.children);
      }
    },
    handleGroupDataChildren(children) {
      let changeChildren = [],
        handleChildren = {};
      for (const child of children) {
        handleChildren =
          this.$dynamicTool.transaction.handleDynamicChildren(child);
        changeChildren.push(handleChildren || child);
      }

      if (this.$verify.isEmptyArray(changeChildren)) {
        this.$emit("groupChildrenChange", children);
        return;
      }
      // this.children = [];
      this.$forceUpdate();
      this.$nextTick(() => {
        this.$set(this, "children", changeChildren);
      });
      this.$emit("groupChildrenChange", changeChildren);
    },
    groupDataChange(groupData, children) {
      this.$set(groupData, "children", children);
      this.$emit("groupChildrenChange", this.children);
    },
    onConditionChange(item, newItem) {
      
      // 将newItem中改变的值赋值给item
      for (const newItemKey in newItem) {
        if (newItem.hasOwnProperty(newItemKey)) {
          let value = newItem[newItemKey];
          if (item.hasOwnProperty(newItemKey) && item[newItemKey] === value) {
            continue;
          }
          if (
            newItemKey === "value" &&
            !this.$verify.isEmptyArray(this.distinctions)
          ) {
            // 如果条件发生变化了-修改其dropdownName值
            let findOne = this.distinctions.find(
              (config) => config.condition === newItem.value
            );
            if (this.$verify.isEmpty(findOne)) {
              if (
                this.$const.ocrMapRe &&
                this.$const.ocrMapRe.hasOwnProperty(newItem.value)
              ) {
                let reKey = this.$const.ocrMapRe[newItem.value]; // 取得特殊映射
                findOne = this.distinctions.find(
                  (config) => config.condition === reKey
                );
              } else {
                // 没得映射
                findOne = { label: "请选择" };
              }
            }
            item.dropdownName = findOne.label;
          }
          this.$set(item, newItemKey, value);
        }
      }
      this.$emit("groupChildrenChange", this.children);
    },
    async addNewOne(labelName) {
      try {
        await this.$dynamicTool.fun.forbidDoubleClick("addNewOne");

        let items = this.items;

        let newOne = JSON.parse(JSON.stringify(items));

        newOne.forEach((item) => {
          if (item.value) {
            delete item.value;
          }
        });
        // if (this.groupData.ocrConfigs && this.groupData.ocrConfigs.length > 1) {
        //     newOne[0].dropdownName = '居民身份证'
        // } else {
        //     newOne[0].dropdownName = ""
        // }

        if (!this.$verify.isEmptyArray(this.distinctions)) {
          newOne[0].dropdownName = this.distinctions[0].label;
        }
        if (labelName !== "反担保人信息") {
          this.children.push(newOne);
        }
        if (labelName == "反担保人信息") {
          this.children.push(newOne);
        }

        this.$emit("groupChildrenChange", this.children);
      } catch (e) {
        this.$dynamicTool.ui.errorToast(e);
      }
    },
    async deleteCur(children, position, label) {
      try {
        await this.$dynamicTool.fun.forbidDoubleClick("deleteCur");
        if (position === 0 && label != "反担保人信息") {
          // 清除当前数据
          console.log(this.children, "没有处理前");
          let child0 = this.children[0];
          let copy = JSON.parse(JSON.stringify(child0));
          for (const childPro of copy) {
            console.log("childPro=", childPro);
            childPro.value = undefined;
            if (
              childPro.label === "权利人" &&
              childPro.key === "estatePerson"
            ) {
              let inside_child = childPro.children[0];
              inside_child.forEach((deep_value) => {
                deep_value.value = undefined;
              });
              childPro.children = [];
              childPro.children.push(inside_child);
            } else {
              childPro.children = [];
            }
          }
          // this.children.splice(0, 1);
          this.$set(this.children, 0, copy);

          console.log("this.children=后", this.children);
        } else {
          this.children.splice(position, 1);
        }
        this.$emit("groupChildrenChange", this.children);
      } catch (e) {
        this.$dynamicTool.ui.errorToast(e);
      }
    },
    //点击下拉
    handleCommand(command, child) {
      console.log("下拉菜单value选择-command=", command, "\nchild=", child);
      if (
        this.$verify.isEmpty(command) ||
        this.$verify.isEmpty(command.condition)
      )
        return;
      let { label, condition } = command,
        finalValue = condition;
      if (child[0].type !== "condition-select") {
        child[0].dropdownName = label;
        return;
      }
      if (!this.$verify.isEmptyArray(child[0].opinions)) {
        let exist = child[0].opinions.some(
          (option) => option.value === condition
        );
        if (!exist) {
          // 不存在-就去全局map中找ocr映射
          if (
            this.$const.ocrMap &&
            this.$const.ocrMap.hasOwnProperty(condition)
          ) {
            finalValue = this.$const.ocrMap[condition];
          } else {
            // 找不到就不进行赋值
            this.$root.$emit("jqBridge", {
              event: "toast",
              data: { msg: "对应参数有误，请联系相关人员", flag: false },
            });
            return;
          }
        }
        // 直接赋值进行后续
        child[0].value = finalValue;
        child[0].dropdownName = label;
        child[0].children = [];
        return;
      }
      this.$root.$emit("jqBridge", {
        event: "toast",
        data: { msg: "对应参数有误，请联系相关人员", flag: false },
      });
      console.log("修改后的children=", this.children);
    },
    doOcr(index, ocrInfo, child) {
      console.log("doOcr-child=", child);
      if (child[0].type === "condition-select")
        ocrInfo.condition = child[0].value;
      // 参数index和key都是后端需要的参数
      let ocrParam = {
        index,
        ocrInfo,
        key: this.key,
      };
      console.log(`---------------[this.ocrParam]--------------`, ocrParam);
      this.$root.$emit("jqBridge", { event: "doOcrNow", data: ocrParam });
    },
    getItemWidth(formItem) {
      let style = "";
      switch (formItem.type) {
        case "condition-picker":
        case "condition-select":
        case "group":
          style += " match-parent-w";
          break;
        case "hidden":
          style += " clearStyle";
          break;
        default:
          style += " margin-top-8 width-parent-48";
          break;
      }
      return style;
    },
    getModification($event) {
      console.log(this.ocrConfigs, "这个里面有好多的数据呢");
      console.log($event, "我看看这个是什么呢");
    },
    getReassemble() {},
  },
};
</script>

<style scoped lang="scss">
@import "src/css/form-style";

.border-bottom-1 {
  border-bottom: 1px solid #ebebeb;
}

.barTitle {
  min-width: 70px;
  height: 100%;
}

.ocrHint {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 40%;

  &:hover {
    text-overflow: inherit;
    overflow-x: scroll;
    white-space: nowrap;
  }
}

::v-deep .el-dropdown-link {
  cursor: pointer;
}
</style>
